<template>
  <iframe :src="authenticatedUrl" class="border-0" style="place-self: stretch" :key="reference" :title="label(presentationStore.votingRound, $i18n.locale as SupportedLocale)"></iframe>
</template>
<script setup lang="ts">
import { useVotingSessionStore } from "@/entrypoints/stores/voting_session";
import { usePresentationStore } from "@/entrypoints/stores/presentation";
import {onMounted, ref} from "vue";
import { label } from "@/entrypoints/shared/voting_rounds_helper";
import { SupportedLocale } from "@assemblyvoting/types";

const props = defineProps<{
  embeddedElectionClientUrl: string,
  reference: string,
}>();

const votingSessionStore = useVotingSessionStore();
const presentationStore = usePresentationStore();

const authenticatedUrl = ref();

function makeAuthenticatedUrl() {
  if (votingSessionStore.authenticateWith.electionCodes) {
    let codes =  "#" + votingSessionStore.authenticateWith.electionCodes.map((code, index) => `${index + 1}:${code}`).join(",");
    return `${props.embeddedElectionClientUrl}/${codes}`;
  } else if (votingSessionStore.authenticateWith.loginsClient) {
    let url = new URL(props.embeddedElectionClientUrl);
    let params = new URLSearchParams({
      session_token: votingSessionStore.authenticateWith.loginsClient.sessionToken,
      hub_slug: votingSessionStore.authenticateWith.loginsClient.hubSlug,
      logins_url: votingSessionStore.authenticateWith.loginsClient.loginsUrl,
    });
    url.hash = params.toString()
    return url.toString();
  }
}

onMounted(() => authenticatedUrl.value = makeAuthenticatedUrl());
</script>